import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SeoService } from './services/utility/seo.service';
import { ChatStateService } from './services/chat/chat-state.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,CalendarModule,FormsModule,ButtonModule,ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'gradpilots';

  constructor(private seoService: SeoService, private chatState: ChatStateService) {
    // SeoService handles robots meta tag updates on route change
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
      // Ensure SignalR disconnects immediately when tab is closed to prevent ghost connections
      this.chatState.disconnect();
  }
}
